import React from "react";
import {Link} from "react-router-dom";
import {getCountriesCall, getGlobalCountriesCall} from "../modules/services/mightyWifiApi";
import Select from 'react-select';

class Global extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      country : null,
      countries : []
    };
    //this.getGlobalCountries();
    this.geCountries();
  }

  geCountries = () => {
    return getCountriesCall().then(res => {
      if (res.status) {
        this.setState({
          countries: res.data
        });
      }
    });
  };

  getGlobalCountries = () => {
    return getGlobalCountriesCall().then(res => {
      if (res.status) {
        this.setState({
          countries: res.data
        });
      }
    });
  };

  onChangeCountry = country => {
    this.setState({
      country: country
    });
  }

  render() {
    const { country } = this.state;
    //console.log(country);

    /*
    const hasDayPassPlan = country != null && typeof country.associated_products !== "undefined" && country.associated_products.length > 0 && typeof country.associated_products[0].recurring_profiles !== "undefined" && country.associated_products[0].recurring_profiles !== null;
    const hasDataPackagePlan = country != null && typeof country.associated_products !== "undefined" && country.associated_products.length > 1 && typeof country.associated_products[1].recurring_profiles !== "undefined" && country.associated_products[1].recurring_profiles !== null;
    */
    /*
    const hasDayPassPlan = country != null && typeof country.associated_products !== "undefined" && country.associated_products.length > 0 && typeof country.associated_products[0].recurring_profiles !== "undefined" && country.associated_products[0].recurring_profiles !== null;
    const hasDataPackagePlan = country != null && typeof country.associated_products !== "undefined" && country.associated_products.length > 1 && typeof country.associated_products[1].recurring_profiles !== "undefined" && country.associated_products[1].recurring_profiles !== null;
    */
    let hasDayPassPlan = false;
    let hasDataPackagePlan = false;
    if(country != null && typeof country.associated_products !== "undefined" && country.associated_products !== null && country.associated_products.length > 0) {
      for (let i = 0; i < country.associated_products.length; i += 1) {
        if (typeof country.associated_products[i].recurring_profiles !== "undefined" && country.associated_products[i].recurring_profiles !== null && country.associated_products[i].recurring_profiles.length > 0) {
          if (country.associated_products[i].type === 'day_pass') {
            hasDayPassPlan = true;
          }
          if (country.associated_products[i].type === 'data_package') {
            hasDataPackagePlan = true;
          }
        }
      }
    }

    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };

    return (
        <section className="section global-section" style={{background: "#3C4F53", padding: "100px 0"}}>


          <div className="container vertical-content text-white">
            <div className="row">

              <div className="col-lg-12">
                {
                  (this.props.type === 'pricing') ? (
                      <div className="globalTitle mb-40">
                        <h2>Global Data Pricing</h2>
                        <div style={{fontSize:"16px",color:"#fbe8b0"}}>
                          <strong className="uppercase">Day Pass :</strong>
                          Day passes offer a more affordable rate and give 1GB per day, refreshing back to 1GB on the next day. This cost-efficient plan is ideal for your single trip where light usage is expected.
                          <br/><br/><strong className="uppercase">Data Plan :</strong>
                          Data plans offer a set amount of data for 30 days starting from the date of activation. Data usage is limited to the data size purchased. This plan is recommended if you want more flexibility in how you use your device.
                        </div> <br/><br/>
                        <h4>Please type a country you are traveling to</h4>
                      </div>
                  )  : (
                      <div className="globalTitle mb-40">
                        <h1 className="Title">MightyWifi and global partners <span className="d-break">have serviced over 60 million users worldwide</span></h1>
                        <p>
                          - Operating since 2003 as a cross-border telecommunications service provider, providing mobile hotspots and SIM cards<br/>
                          - Our partners have offices in the U.S., China, South Korea, Japan, Singapore, Thailand, and Europe<br/>
                          - Our global data serves over 200 countries, and the list continues to grow
                        </p>
                      </div>
                  )
                }
              </div>

              <div style={clearStyle} />

              <div className="col-lg-5 text-black">
                {/*<input
                type="text"
                name="keyword"
                ref=""
                onChange=""
                className="form-control"
                placeholder="TYPE YOUR DESTINATION"
                className="GlobalSearchBox"
              />*/}
                <Select
                    getOptionLabel ={(option)=>option.name}
                    getOptionValue ={(option)=>option.code}
                    onChange={this.onChangeCountry}
                    options={this.state.countries}
                    placeholder="TYPE YOUR DESTINATION"
                />
                {/*<div className="GrobalResult">
              <div>United States</div>
              <div>Soutth Korea</div>
              <div>Japan</div>
              <div>Maxico</div>
              <div>United States</div>
              <div>Soutth Korea</div>
              <div>Japan</div>
              </div>*/}
                {
                  (country != null) ? (

                      <div id="accordion" className="mt-3">

                        {
                          hasDayPassPlan ? (

                              <div className="card">
                                <div className="card-header" id="headingTwo">
                                  <h5 className="mb-0 SansSerif">
                                    <button className={`btn btn-link btn-white ` + ((hasDataPackagePlan) ? `collapsed` : ``)} data-toggle="collapse" data-target="#collapseTwo" aria-expanded={((hasDataPackagePlan) ? `false` : `true`)} aria-controls="collapseTwo">
                                      Day Pass
                                    </button>
                                  </h5>
                                </div>
                                <div id="collapseTwo" className={`collapse` + ((hasDataPackagePlan) ? `` : `show`)} aria-labelledby="headingTwo" data-parent="#accordion">
                                  <div className="card-body">
                                    <table className="table">
                                      <tbody>
                                      {
                                        country.associated_products[0].recurring_profiles.map(
                                            recurring_profile => (
                                                (recurring_profile.price > 0) ?
                                                    <tr>
                                                      <td>{recurring_profile.name}</td>
                                                      <td className="bold600">${recurring_profile.price}</td>
                                                      <td className="table-btn">
                                                        <Link className="btn btn-white" to={{
                                                          pathname: "/buy/device",
                                                          state : {
                                                            useType : country.type,
                                                            country : country,
                                                            associatedProduct : country.associated_products[0],
                                                            recurringProfile : recurring_profile,
                                                            anchor : 'GlobalPoint'
                                                          }
                                                        }}>
                                                          SHOP NOW
                                                        </Link>
                                                        {/*<a className="btn btn-white" href={`/buy/device/` + (country.type + `/` + country._id + `/` + country.associated_products[0]._id + `/` + recurring_profile._id) + `/#GlobalPoint`}>SHOP NOW</a>*/}
                                                      </td>
                                                    </tr>
                                                    : null
                                            )
                                        )
                                      }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                          ) : null
                        }

                        {
                          hasDataPackagePlan ? (

                              <div className="card">
                                <div className="card-header" id="headingOne">
                                  <h5 className="mb-0 SansSerif">
                                    <button class="btn btn-link btn-white" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                      Data Packages
                                    </button>
                                  </h5>
                                </div>
                                <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                  <div className="card-body">
                                    <table className="table">
                                      <tbody>
                                      {
                                        country.associated_products[hasDayPassPlan ? 1 : 0].recurring_profiles.map(
                                            recurring_profile => (
                                                (recurring_profile.status === 1 && recurring_profile.price > 0) ?
                                                    <tr>
                                                      <td>{recurring_profile.name}</td>
                                                      <td className="bold600">${recurring_profile.price}</td>
                                                      <td className="table-btn">
                                                        <Link className="btn btn-white" to={{
                                                          pathname: "/buy/device",
                                                          state : {
                                                            useType : country.type,
                                                            country : country,
                                                            associatedProduct : country.associated_products[hasDayPassPlan ? 1 : 0],
                                                            recurringProfile : recurring_profile,
                                                            anchor : 'GlobalPoint'
                                                          }
                                                        }}>
                                                          SHOP NOW
                                                        </Link>
                                                        {/*<a className="btn btn-white" href={`/buy/device/` + (country.type + `/` + country._id + `/` + country.associated_products[hasDayPassPlan ? 1 : 0]._id + `/` + recurring_profile._id + `/#GlobalPoint`)}>SHOP NOW</a>*/}
                                                      </td>
                                                    </tr>
                                                    : null
                                            )
                                        )
                                      }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>

                          ) : null
                        }

                      </div>

                  ) : null
                }

              </div>
              <div className="col-lg-7 global-map" style={PaddingStyle}>
                <div className="MapImage"><img src="/images/map.svg" alt="" className="img-fluid mx-auto d-block"/></div>
              </div>
            </div>
          </div>

        </section>
    );
  }
}

export default Global;



// WEBPACK FOOTER //
// ./src/layout/Global.js